// @flow
import InsuranceButton from './InsuranceButton'

export default InsuranceButton
